import type { RouteRecordRaw } from "vue-router";

export const DashboardsRoutes: RouteRecordRaw[] = [
  {
    path: "/dashboards",
    name: "dashboards",
    component: () => import("@cms/features/Dashboards/DashboardsContainer.vue"),
    redirect: { name: "messenger-dashboard" },
    children: [
      {
        path: "messenger",
        name: "messenger-dashboard",
        component: () => import("@cms/features/Messenger/MessengerDashboardV2.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "last-activity",
        name: "last-activity-dashboard",
        component: () => import("@cms/features/Dashboards/LastActivityDashboard.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "usage",
        name: "usage-dashboard",
        component: () => import("@cms/features/Usage/UsageDashboard.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "ai",
        name: "ai-dashboard",
        component: () => import("@cms/features/AiUsage/AiUsageDashboard.vue"),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];
